import React from 'react';
import styled from 'styled-components';
import { PageContainer } from '../layouts';

export default (props) => {
    return (
        <PageContainer component="main" maxWidth="sm">
            <Container className="not-found-page-container" fontSize={'4rem'}>
                Page Not Found
            </Container>
        </PageContainer>
    )
}

const Container = styled.div`
    font-size: ${p => p.fontSize ? p.fontSize : "3rem"};
`;

